import { Box, Flex, Image, Grid, Text } from "@theme-ui/components"
import React, { useEffect, useState } from "react"
import { useMenu } from "../hooks/useMenu"
import { getHomePath, getProductsPath } from "../utils/path"
import { InboundLink, OutboundLink } from "./link"
import { MagicLink } from "../utils/magicLink"
import LanguageSwitcher from "./languageSwitcher"
import { debounce } from "lodash"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import Logo from "../images/cmatic-logo.svg"
import LogoWhite from "../images/cmatic-logo-white.svg"
import ChevronUpIcon from "../images/Arrow_Down-blue.inline.svg"
import DownloadIcon from "../images/Download.inline.svg"
import { i18nContext } from "../context/i18nContext"
import SearchBar from "./searchBar"
import { ShoppingCart } from "react-feather"

const Nav = ({ theme, home = false }) => {
  const locale = React.useContext(LanguageSwitcherContext).activeLocale
  const menu = useMenu()
  const [show, setShow] = useState(false)
  const [showDropdown, setShowDropdown] = useState(null)
  const [showSubDropdown, setShowSubDropdown] = useState(null)

  menu.map(menuItem => {
    menuItem.treeChildren.sort((a, b) => a.position - b.position)
    menuItem.treeChildren.map(menuItem => {
      if (menuItem.treeChildren.length > 0) {
        menuItem.treeChildren.sort((a, b) => a.position - b.position)
      }
    })
  })

  return (
    <i18nContext.Consumer>
      {t => (
        <>
          <Box as="nav">
            <Box sx={{ position: "absolute", top: [3, 4, 5], left: [3, 4] }}>
              <InboundLink to={getHomePath(locale)}>
                <Image
                  sx={{
                    maxHeight: ["45px", "50px", "74px"],
                  }}
                  src={theme === "light" ? Logo : LogoWhite}
                />
              </InboundLink>
            </Box>
            <Box sx={{ position: "absolute", top: "50px", right: "153px" }}>
              <InboundLink
                to={getProductsPath(t.locale)}
                sx={{
                  display: "flex",
                  py: [2],
                  px: [3],
                  color: home ? "dark" : theme === "light" ? "dark" : "light",
                  border: "1px solid",
                  borderColor: home
                    ? "dark"
                    : theme === "light"
                    ? "dark"
                    : "light",

                  textTransform: "uppercase",
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none",
                  svg: {
                    height: "100%",
                    width: "auto",
                    mr: [2],
                    stroke: home
                      ? "dark"
                      : theme === "light"
                      ? "dark"
                      : "light",
                  },
                  fontSize: [4],
                  "&:hover": {
                    color: "light",
                    borderColor: "light",
                    backgroundColor: "primary",
                    svg: {
                      stroke: "light",
                    },
                  },
                }}
              >
                <Box>{t.allProducts}</Box>
              </InboundLink>
            </Box>
            <Box
              sx={{
                zIndex: 9999,
                boxSizing: "border-box",
                margin: "0",
                minWidth: "0",
                right: "0px",
                position: "fixed",
                background: "red",
                width: "78px",
                height: "100%",
                overflowY: "auto",
                backgroundColor: !show ? "menuSidebarBackground" : "primary",
                py: [4],
              }}
            >
              <Flex
                sx={{
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "center",
                  position: "relative",
                  height: "100%",
                  width: "100%",
                }}
              >
                <Box>
                  <Box
                    sx={{
                      zIndex: 9999,
                    }}
                    onClick={() => {
                      setShowDropdown(null)
                      setShowSubDropdown(null)
                      setShow(!show)
                    }}
                  >
                    <Hamburger show={show} />
                  </Box>
                  <Flex
                    sx={{
                      justifyContent: "center",
                      mt: [4],
                      a: { color: "dark" },
                    }}
                  >
                    <OutboundLink
                      href="https://gow.cmatic.it/home.aspx"
                      target="_blank"
                    >
                      <ShoppingCart />
                    </OutboundLink>
                  </Flex>
                </Box>
                <Flex
                  sx={{
                    zIndex: 99999,
                    flexDirection: "row",
                    margin: 0,
                    listStyle: "none",
                    fontSize: [2],
                  }}
                >
                  <LanguageSwitcher />
                </Flex>
              </Flex>
            </Box>
            <AccountSideBar
              open={show}
              menu={menu}
              locale={locale}
              theme={theme}
              setShowDropdown={setShowDropdown}
              setShowSubDropdown={setShowSubDropdown}
              setShow={setShow}
            />
          </Box>
        </>
      )}
    </i18nContext.Consumer>
  )
}

const AccountSideBar = ({
  open,
  menu,
  locale,
  theme,
  setShowDropdown,
  setShowSubDropdown,
  setShow,
}) => {
  const [showIndex, setShowIndex] = useState(null)
  const [showSubIndex, setShowSubIndex] = useState(null)
  const [windowHeight, setWindowHeight] = useState(null)

  const handleShowIndex = index => {
    setShowIndex(index)
  }

  const handleShowSubIndex = index => {
    setShowSubIndex(index)
  }

  useEffect(() => {
    const appHeight = () => {
      // const doc = document.documentElement
      // doc.style.setProperty("--app-height", `${window.innerHeight}px`)
      setWindowHeight(window.innerHeight)
    }
    window.addEventListener("resize", appHeight)
    appHeight()
  }, [])

  return (
    <i18nContext.Consumer>
      {t => (
        <>
          <Box
            sx={{
              display: "block",
              position: "fixed",
              zIndex: 333,
              top: "0",
              bottom: "0",
              right: "79px",
              left: "0",
              backgroundColor: "#000",
              transition: "all .2s ease",
              opacity: open ? ".25" : "0",
              pointerEvents: open ? "all" : "none",
              willChange: open && "opacity",
            }}
            onClick={() => {
              setShowDropdown(null)
              setShowSubDropdown(null)
              setShow(false)
            }}
          />
          <Box
            sx={{
              display: "block",
              boxSizing: "border-box",
              position: "fixed",
              width: ["calc(100% - 79px)"],
              maxWidth: "1342px",
              px: [4, 4, 4, 8],
              pt: [8, windowHeight <= 720 ? 6 : 8, windowHeight <= 720 ? 6 : 8],
              pb: [8, windowHeight <= 720 ? 6 : 8],
              height: "100vh",
              right: "-1px",
              top: "0",
              backgroundColor: "#ffffff",
              overflow: "auto",
              zIndex: 3333,
              transition: "transform 200ms 0s",
              transitionProperty: "transform,visibility,width",
              transform: open ? "translateX(-79px)" : "translateX(100%)",
              visibility: open ? "" : "hidden",
            }}
          >
            <Flex
              sx={{
                flexDirection: "column",
                width: "100%",
                justifyContent: "space-between",
                height: "100%",
                maxWidth: "1120px",
              }}
            >
              <Box>
                <Flex
                  sx={{
                    flexDirection: "row",
                    padding: 0,
                    margin: 0,
                    listStyle: "none",
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                  as="ul"
                >
                  {menu.map((item, index) => (
                    <TextComponent
                      item={item}
                      locale={locale}
                      index={index}
                      key={item.id}
                      handleShowIndex={handleShowIndex}
                      showIndex={showIndex}
                    />
                  ))}
                </Flex>
                <Box
                  sx={{
                    position: "relative",
                  }}
                >
                  {menu.map(
                    (item, index) =>
                      item.treeChildren.length > 0 && (
                        <Box
                          as="ul"
                          sx={{
                            pt: [5],
                            opacity: showIndex === index ? 1 : 0,
                            zIndex: showIndex === index ? 10 : -1,
                            listStyle: "none",
                            px: [0, 0],
                            margin: 0,
                            position: "absolute",
                            "&:last-child": {
                              position: "relative",
                              mb: 3,
                            },
                            top: 0,
                            left: 0,
                            minHeight: "720",
                            display: "flex",
                            justifyContent: "flex-start",
                            width: "100%",
                          }}
                          onMouseEnter={() => handleShowIndex(index)}
                          onMouseLeave={() => handleShowIndex(index)}
                        >
                          {item.treeChildren.map((subItem, subIndex) =>
                            subItem.anchor ? (
                              <Box
                                as="li"
                                key={subItem.id}
                                sx={{
                                  position: "relative",
                                  marginX: 1,
                                  px: [2],
                                  mr: [4, 5, 6],
                                  textTransform: "uppercase",
                                  // minWidth: "244px",
                                  maxWidth: "244px",
                                  fontSize: [3],
                                  letterSpacing: ["-0.56px"],
                                  fontWeight: "400",
                                  "&:hover": {
                                    color: "primary",
                                  },
                                  a: {
                                    "&.active": {
                                      color: "primary",
                                    },
                                    textTransform: "uppercase",
                                    fontSize: "inherit",
                                    color: "dark",
                                    letterSpacing: "inherit",
                                    fontWeight: "inherit",
                                    textDecoration: "none",
                                    "&:hover": {
                                      color: "primary",
                                    },
                                  },
                                }}
                              >
                                {subItem.link ? (
                                  <Box
                                    sx={{
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    // onMouseEnter={() =>
                                    //   handleShowSubIndex(subIndex)
                                    // }
                                    onClick={() =>
                                      handleShowSubIndex(
                                        subIndex === showSubIndex
                                          ? null
                                          : subIndex
                                      )
                                    }
                                  >
                                    <Box sx={{ fontFamily: "roc" }}>
                                      <MagicLink
                                        sx={{
                                          display: "block",
                                        }}
                                        item={subItem.link}
                                        locale={locale}
                                      />
                                    </Box>
                                  </Box>
                                ) : (
                                  <>
                                    <Box
                                      sx={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                      // onMouseEnter={() =>
                                      //   handleShowSubIndex(subIndex)
                                      // }
                                      onClick={() =>
                                        handleShowSubIndex(
                                          subIndex === showSubIndex
                                            ? null
                                            : subIndex
                                        )
                                      }
                                    >
                                      <Box sx={{ pr: [2], fontFamily: "roc" }}>
                                        {subItem.anchor}
                                      </Box>
                                      <Box
                                        sx={{
                                          height: "100%",
                                          display: "flex",
                                          alignItems: "center",
                                          svg: {
                                            stroke:
                                              subIndex === showSubIndex
                                                ? "primary"
                                                : "dark",
                                            transform:
                                              subIndex === showSubIndex &&
                                              "rotate(180deg)",
                                            transition: "all .2s ease",
                                          },
                                        }}
                                      >
                                        <ChevronUpIcon />
                                      </Box>
                                    </Box>
                                    <Box
                                      as="ul"
                                      sx={{
                                        pl: [0],
                                        listStyle: "none",
                                        position: "absolute",
                                      }}
                                    >
                                      {subItem.treeChildren &&
                                        subIndex === showSubIndex &&
                                        subItem.treeChildren.map(
                                          (subSubItem, index) => (
                                            <Box
                                              as="li"
                                              sx={{
                                                py: [2],
                                                position: "relative",
                                                // textTransform: "lowercase",
                                                minWidth: "244px",
                                                maxWidth: "244px",
                                                fontSize: [3],
                                                letterSpacing: ["-0.56px"],
                                                fontWeight: "400",
                                                "&:hover": {
                                                  color: "primary",
                                                },
                                                a: {
                                                  // textTransform: "lowercase",
                                                  fontSize: "inherit",
                                                  color: "dark",
                                                  letterSpacing: "inherit",
                                                  fontWeight: "inherit",
                                                  textDecoration: "none",
                                                  "&:hover": {
                                                    color: "primary",
                                                  },
                                                },
                                              }}
                                            >
                                              {subSubItem.link ? (
                                                <>
                                                  <MagicLink
                                                    item={subSubItem.link}
                                                    locale={locale}
                                                    target=""
                                                  ></MagicLink>
                                                </>
                                              ) : (
                                                <Box sx={{ cursor: "default" }}>
                                                  {subSubItem.anchor}
                                                </Box>
                                              )}
                                            </Box>
                                          )
                                        )}
                                    </Box>
                                  </>
                                )}
                              </Box>
                            ) : null
                          )}
                        </Box>
                      )
                  )}
                  <Box></Box>
                </Box>
              </Box>
              <Grid columns={[1, 2]}>
                <Box sx={{ position: "relative", mr: [2], width: "100%" }}>
                  <InboundLink
                    to={`${
                      locale != "en" ? "/" + t.locale.toLowerCase() : ""
                    }/download`}
                    sx={{
                      display: "flex",
                      py: [2],
                      px: [3],
                      color: "dark",
                      border: "1px solid",
                      borderColor: "dark",
                      textTransform: "uppercase",
                      display: "flex",
                      alignItems: "center",
                      textDecoration: "none",
                      svg: {
                        height: "100%",
                        width: "auto",
                        mr: [2],
                        stroke: "dark",
                      },
                      fontSize: [4],
                      "&:hover": {
                        color: "light",
                        borderColor: "light",
                        backgroundColor: "primary",
                        svg: {
                          stroke: "light",
                        },
                      },
                    }}
                  >
                    <DownloadIcon />
                    <Box>{t.downloadCatalogue}</Box>
                  </InboundLink>
                </Box>
                <Box>
                  <SearchBar />
                </Box>
              </Grid>
            </Flex>
          </Box>
        </>
      )}
    </i18nContext.Consumer>
  )
}

const TextComponent = ({ item, locale, index, handleShowIndex, showIndex }) => {
  const [show, setShow] = useState(false)

  const debouncedHandleMouseEnterMenu = debounce(() => {
    setShow(true)
    handleShowIndex(index)
  }, 0)

  const handlOnMouseLeaveMenu = () => {
    setShow(false)
    handleShowIndex(null)
    debouncedHandleMouseEnterMenu.cancel()
  }

  const handleClick = () => {
    if (index === showIndex) {
      setShow(false)
      handleShowIndex(null)
    } else {
      setShow(true)
      handleShowIndex(index)
    }
  }

  useEffect(() => {
    setShow(showIndex === index)
  }, [showIndex])

  return (
    <Box
      as="li"
      key={item.id}
      sx={{
        position: "relative",
        marginX: 1,
        paddingX: 2,
        paddingY: 3,
        // textTransform: "lowercase",
        fontSize: ["28px"],
        letterSpacing: ["-0.56px"],
        fontWeight: "400",
        "&:hover": {
          color: "primary",
        },
        a: {
          // textTransform: "lowercase",
          fontSize: "inherit",
          color: "dark",
          letterSpacing: "inherit",
          fontWeight: "inherit",
          textDecoration: "none",
          "&:hover": {
            color: "primary",
          },
        },
      }}
      // onMouseEnter={() => debouncedHandleMouseEnterMenu()}
      // onMouseLeave={() => handlOnMouseLeaveMenu()}
      onClick={() => {
        handleClick()
      }}
    >
      {item.link ? (
        <Box sx={{ cursor: "pointer", display: "flex" }}>
          <Box>
            <MagicLink item={item.link} locale={locale}></MagicLink>
          </Box>
        </Box>
      ) : (
        <Box sx={{ cursor: "pointer", display: "flex" }}>
          <Box
            sx={{
              pr: [2],
              color: showIndex === index ? "primary" : "dark",
              transition: "all .2s ease",
            }}
          >
            {item.anchor}
          </Box>
          <Box
            sx={{
              svg: {
                stroke: showIndex === index ? "primary" : "dark",
                transform: showIndex === index && "rotate(180deg)",
                transition: "all .2s ease",
              },
            }}
          >
            <ChevronUpIcon />
          </Box>
        </Box>
      )}
    </Box>
  )
}

const Hamburger = ({ show }) => {
  return (
    <Flex
      sx={{
        cursor: "pointer",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        className={show ? "show" : ""}
        sx={{
          width: "25px",
          "&:before,&:after": {
            borderRadius: "sm",
            content: "''",
            backgroundColor: "dark",
            display: "block",
            height: "2px",
            my: [3],
            transition: "transform .15s ease-in-out, opacity .0s ease-in-out",
          },
          "&.show:before": {
            transform: "translateY(8px) rotate(135deg)",
          },
          "&.show:after": {
            transform: "translateY(-10px) rotate(-135deg)",
          },
        }}
      >
        <Box></Box>
      </Box>
      <Box sx={{ py: [3] }}>
        <Text
          sx={{
            display: "block",
            transformOrigin: "50% 50%",
            transform: "rotate(90deg)",
            textTransform: "uppercase",
            fontSize: [0],
          }}
        >
          MENU
        </Text>
      </Box>
    </Flex>
  )
}

export default Nav
